export enum LayoutImageOptions {
    UNKNOWN = 0,
    HAS_ANY = 1
}
